import { Link } from "react-router-dom";

const AboutPortfolioLink = () => {
  return (
    <div id="portfolio" className="block spacer p-top-xl">
      <div className="text-center">
        <Link
          title="Our portfolio"
          className="btn btn-outline-primary text-uppercase"
          to={"/portfolio"}
        >
          Our portfolio
        </Link>
      </div>
    </div>
  );
};

export default AboutPortfolioLink;
